import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { tap } from 'rxjs';
import { FlattenedQuestionHolder } from 'src/app/core-module/models/Audits/flattened-question-holder';
import { ProgramFeatures } from 'src/app/core-module/models/UserManagement/program-features';
import { AuthService } from 'src/app/core-module/services/auth.service';
import { UserManagementService } from 'src/app/core-module/services/usermanagement.service';

@Component({
    selector: 'app-edit-entry-options',
    templateUrl: './edit-entry-options.component.html',
    styleUrls: ['./edit-entry-options.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditEntryOptionsComponent {

  public hasCampaignPermission:boolean = false;
  public hasEventPermission:boolean = false;
  public canEditInternalAudits:boolean = false;


  @Input() public audit:FlattenedQuestionHolder;
  @Output() auditChange: EventEmitter<FlattenedQuestionHolder> = new EventEmitter<FlattenedQuestionHolder>();

  constructor(private auth:AuthService, private userManagement:UserManagementService){
    this.getFeaturePermissions();
    this.getUserSettingsPermissions();
  }

  

  auditChanged(){
    this.audit.AuditMetaData.Internal = this.audit.AuditEntryOptions.InternalAudit;
    this.auditChange.emit(this.audit);
  }
 getFeaturePermissions(){ 
      this.auth.getFeaturePermissions().pipe(
        tap((res:ProgramFeatures) => {
          if (!res.IsError){
            this.hasCampaignPermission = res.Campaigns;
            this.hasEventPermission = res.Events;
          }
        })
      ).subscribe();
    }

  getUserSettingsPermissions(){
    this.userManagement.userSettingsPermissions().pipe(
      tap(res => {
        this.canEditInternalAudits = !res.IsError && res.CanEditInternalAudits;
      })
    ).subscribe();
  }
  

}
